import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getNexusTokens } from '../../theme/tokens';

/**
 * Standard page title row (Phase 7.2).
 */
export default function PageHeader({
  title,
  subtitle,
  icon,
  actions,
  gradientTitle = false,
  sx,
}) {
  const theme = useTheme();
  const tokens = getNexusTokens(theme);

  return (
    <Box
      sx={{
        mb: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 2,
        ...sx,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            ...tokens.typography.pageTitle,
            color: tokens.colors.text.primary,
            mb: subtitle ? 1 : 0,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            ...(gradientTitle && {
              background: `linear-gradient(135deg, ${tokens.colors.text.primary} 0%, ${tokens.colors.accent.primary} 100%)`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }),
          }}
        >
          {icon}
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body1"
            sx={{ color: tokens.colors.text.muted }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
